import { IFieldReview } from '../components/review/form/FieldList';
import { IField } from '../types/my-types';

type FieldOrString = IFieldReview | IField | string;

const combineFields = (fields: FieldOrString[]): string[] => {
  return fields.map((field) => {
    if (typeof field === 'string') {
      return field;
    } else {
      return field.label;
    }
  });
};

export const getNextActiveField = (fields: FieldOrString[], activeField: string) => {
  const combinedFields = combineFields(fields);

  const activeFieldIndex = combinedFields.indexOf(activeField);

  // if active field is not found, return false
  if (activeFieldIndex === -1) {
    return false;
  }

  // if active field is the last field, return false
  if (activeFieldIndex === combinedFields.length - 1) {
    return false;
  }

  // return the next field
  return combinedFields[activeFieldIndex + 1];
};
